import React, { useRef } from 'react';
import FooterBrand from './components/footer/FooterBrand';
import FooterNav from './components/footer/FooterNav';
import FooterFishIllustration from './components/footer/FooterFishIllustration';
import FooterLocationRow from './components/footer/FooterLocationRow';
import FooterTrustRow from './components/footer/FooterTrustRow';
import FooterLegalBar from './components/footer/FooterLegalBar';
import OrganisationSchema from './components/footer/OrganisationSchema';
import { useFooterReveal } from './components/footer/utils/useFooterReveal';
import './assets/css/footer.css';
import './assets/css/footer_reveal.css';

function Footer() {
  const footerRef = useRef(null);
  const isRevealActive = useFooterReveal(footerRef);

  return (
    <footer
      ref={footerRef}
      className={`sbf${isRevealActive ? ' sbf--reveal' : ''}`}
    >
      <OrganisationSchema />
      <div className='sbf__content display-flex-column'>
        <div className='sbf__top flex-wrap' data-sbf-reveal>
          <FooterBrand />
          <FooterNav />
        </div>

        <div className='sbf-divider' data-sbf-reveal>
          <FooterFishIllustration />
        </div>

        <FooterLocationRow />
        <FooterTrustRow />
        <FooterLegalBar />
      </div>
    </footer>
  );
}

export default Footer;
